/* unplugin-vue-components disabled */import { render } from "./BaseChoice.vue?vue&type=template&id=411a0136"
import script from "./BaseChoice.vue?vue&type=script&lang=js"
export * from "./BaseChoice.vue?vue&type=script&lang=js"

import "./BaseChoice.vue?vue&type=style&index=0&id=411a0136&lang=scss"
script.render = render

export default script